import {
  getBreadCrumbList,
  setTagNavListInLocalstorage,
  getMenuByRouter,
  getTagNavListFromLocalstorage,
  getHomeRoute,
  getNextRoute,
  routeHasExist,
  routeEqual,
  getRouteTitleHandled,
  localSave
  // localRead
} from '@/libs/utils'
// import http from '@/middleware/http'
import routers from '@/router/routers'
import router from '@/router'
import config from '@/config'
import { storage } from '../../libs/tools'

const { HOME_NAME } = config

const closePage = (state, route) => {
  const nextRoute = getNextRoute(state.tagNavList, route)
  state.tagNavList = state.tagNavList.filter(item => {
    return !routeEqual(item, route)
  })
  router.push(nextRoute)
}

export default {
  state: {
    copyright: `@${new Date().getFullYear()} Beepay Limited`,
    breadCrumbList: [],
    tagNavList: [],
    homeRoute: {},
    // local: localRead('local'),
    errorList: [],
    hasReadErrorPage: true,
    showErrorStatus: false, // 这里配置是否展示Main.vue上bug展示，后台决定是否展示
    menuList: []
  },
  getters: {
    copyright: state => state.copyright,
    menuList: (state, getters, rootState) => {
      let stash = rootState.app.menuList || []
      stash = stash.length === 0 ? storage.getItem('menuList') : state.menuList
      let accessList = getMenuByRouter(routers, rootState.user.access, stash)
      return accessList
    },
    errorCount: state => state.errorList.length,
    showErrorStatus: state => {
      return state.showErrorStatus ? state.showErrorStatus : storage.getItem('showErrorStatus')
    }
  },
  mutations: {
    setBreadCrumb (state, route) {
      state.breadCrumbList = getBreadCrumbList(route, state.homeRoute)
    },
    setHomeRoute (state, routes) {
      state.homeRoute = getHomeRoute(routes, HOME_NAME)
    },
    setTagNavList (state, list) {
      let tagList = []
      if (list) {
        tagList = [...list]
      } else {
        tagList = getTagNavListFromLocalstorage() || []
      }
      if (tagList[0] && tagList[0].name !== HOME_NAME) tagList.shift()
      let homeTagIndex = tagList.findIndex(item => item.name === HOME_NAME)
      if (homeTagIndex > 0) {
        let homeTag = tagList.splice(homeTagIndex, 1)[0]
        tagList.unshift(homeTag)
      }
      state.tagNavList = tagList
      setTagNavListInLocalstorage([...tagList])
    },
    closeTag (state, route) {
      let tag = state.tagNavList.filter(item => routeEqual(item, route))
      route = tag[0] ? tag[0] : null
      if (!route) return
      closePage(state, route)
    },
    addTag (state, { route, type = 'unshift' }) {
      let router = getRouteTitleHandled(route)
      if (!routeHasExist(state.tagNavList, router)) {
        if (type === 'push') {
          state.tagNavList.push(router)
        } else {
          if (router.name === HOME_NAME) {
            state.tagNavList.unshift(router)
          } else {
            state.tagNavList.splice(1, 0, router)
          }
        }
        setTagNavListInLocalstorage([...state.tagNavList])
      }
    },
    setLocal (state, lang) {
      localSave('local', lang)
      state.local = lang
    },
    addError (state, error) {
      state.errorList.push(error)
    },
    setHasReadErrorLoggerStatus (state, status = true) {
      state.hasReadErrorPage = status
    },
    setMenuList (state, list) {
      state.menuList = list
      storage.setItem('menuList', list)
    },
    setShowErrorStatus (state, menuList = []) {
      let flag = menuList.some(it => it.path === '/ErrorLogger')
      state.showErrorStatus = flag || false
      storage.setItem('showErrorStatus', flag)
    }
  },
  actions: {
    addErrorLog ({ commit, rootState }, info) {
      // if (!window.location.href.includes('error_logger_page'))
      commit('setHasReadErrorLoggerStatus', false)
      const { user: { token, userId, userName } } = rootState
      let data = {
        ...info,
        time: Date.parse(new Date()),
        token,
        userId,
        userName
      }
      // console.debug('%cdebug: %s', stylesheet.debug.join(';'), JSON.stringify(data))
      commit('addError', data)
      // saveErrorLogger(info).then(() => {
      //   commit('addError', data)
      // })
    }
  }
}
